export default __webpack_public_path__ + "static/media/rp_sprite_card.bfeaeeab.png";